/**
 * withProducts
 * HOC for wrapping the provided component with ProductsProvider
 */

import React from 'react'

import ProductsProvider from './products-provider'

export default function withProducts (WrappedComponent) {
  return function ProductsProviderHOC(props) {
    return (
      <ProductsProvider>
        <WrappedComponent {...props} />
      </ProductsProvider>
    )
  }
}
